module.exports = __webpack_public_path__ + "img/arrow-down-teal.7150cb28.svg";